import { rgba } from 'polished';
import styled, { css } from 'styled-components';
import { ifNotProp, ifProp, palette } from 'styled-tools';

import { FormInput, maxWidth, minWidth, QuestionnaireTile, Text } from '@calm-web/design-system';

export const Title = styled(Text).attrs({
	color: 'gray7',
	styleAs: 'h4',
	el: 'h1',
})<{
	hasMargin: boolean;
}>`
	margin-bottom: ${(props): string => (props.hasMargin ? '40px' : '8px')};
	margin-top: 8px;
	outline: none;
	${minWidth('tablet')} {
		margin-top: 0;
	}
`;

export const Subtitle = styled.p`
	color: ${palette('gray8')};
	font-size: 16px;
	margin-bottom: 24px;
`;

export const Choices = styled.div`
	align-items: stretch;
	display: flex;
	flex-direction: column;
	position: relative;
`;

export const Choice = styled(QuestionnaireTile)<{
	$transitionDelay: number;
	$isEntering: boolean;
}>`
	opacity: ${ifProp('$isEntering', 0, 1)};
	transition-delay: ${props => props.$transitionDelay}ms;
	transform: ${ifProp('$isEntering', 'translateY(8px)', 'translateY(0)')};
	border-radius: 12px;

	&:hover:before,
	&:before {
		border-radius: 12px;
	}
`;

export const AnimatedContainer = styled.div<{
	isVisible: boolean;
	isSelected: boolean;
	shouldAnimate: boolean;
}>`
	opacity: ${(props): number => (props.isVisible ? 1 : 0)};
	${(props): string => (props.isVisible ? 'margin-bottom: 8px; max-height: 140px;' : 'max-height: 0')};
	visibility: ${(props): string => (props.isVisible ? 'visible' : 'hidden')};
	${(props): string =>
		props.shouldAnimate
			? `
        transition: 300ms ease-in-out;
        transition-delay: 200ms;
      `
			: ''}
`;

export const AnimatedResponse = styled.div<{
	isVisible: boolean;
	shouldAnimate: boolean;
	compact?: boolean;
}>`
	opacity: ${ifProp('isVisible', '1', '0')};
	position: relative;

	${(props): string =>
		props.shouldAnimate
			? `
      transition: 300ms ease-in-out;
      transition-delay: 500ms;
    `
			: ''}
	& p {
		margin-bottom: 40px;
		&:last-of-type {
			margin-bottom: 0;
		}
	}
`;

export const NavButtonsWrapper = styled.div<{
	isVisible: boolean;
	shouldAnimate: boolean;
	compact?: boolean;
}>`
	display: flex;
	width: 100%;
	${maxWidth('tablet')} {
		padding-bottom: 24px;
	}
	${ifNotProp(
		'isVisible',
		ifProp(
			'compact',
			css`
				display: none;
			`,
		),
	)}
	${(props): string =>
		props.shouldAnimate
			? `
        transition: 300ms ease-in-out;
        transition-delay: 500ms;
      `
			: ''}
  ${minWidth('desktopLarge')} {
		position: static;
	}
	${ifProp(
		'compact',
		css`
			position: relative;
		`,
	)}
`;

export const PollBodyContainer = styled.div`
	margin-top: 26px;
`;

export const TextArea = styled(FormInput)`
	& > div {
		background-color: ${props => rgba(palette('black')(props), 0.3)};
	}

	input {
		color: ${palette('white')};
		border: 1px solid ${props => rgba(palette('white')(props), 0.4)};
	}
`;

export const QuestionCount = styled(Text)`
	display: none;

	${minWidth('tablet')} {
		display: block;
	}
`;
